import React from "react";
import ReactDOM from "react-dom/client";
import { ThemeProvider } from "./context/ThemeContext";

import App from "./App";
import axios from "axios";
import { resolveBaseURL } from "./apiConfig";

axios.defaults.withCredentials = true;
axios.defaults.baseURL = resolveBaseURL();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>
);
